export const FETCH_USER_AUTHENTICATION_WATCHER =
  "FETCH_USER_AUTHENTICATION_WATCHER";
export const SET_USER_AUTHENTICATION = "SET_USER_AUTHENTICATION";
export const SET_USER_AUTHENTICATION_ERROR = "SET_USER_AUTHENTICATION_ERROR";

export const GET_CBP_REQUEST_MESSAGE_WATCHER =
  "GET_CBP_REQUEST_MESSAGE_WATCHER";
export const SET_CBP_REQUEST_MESSAGE = "SET_CBP_REQUEST_MESSAGE";
export const SET_CBP_REQUEST_MESSAGE_ERROR = "SET_CBP_REQUEST_MESSAGE_ERROR";

export const GET_CBP_RESPONSE_MESSAGE_WATCHER =
  "GET_CBP_RESPONSE_MESSAGE_WATCHER";
export const SET_CBP_RESPONSE_MESSAGE = "SET_CBP_RESPONSE_MESSAGE";
export const SET_CBP_RESPONSE_MESSAGE_ERROR = "SET_CBP_RESPONSE_MESSAGE_ERROR";

export const ADD_FILE_REQUEST_RECORD_WATCHER =
  "ADD_FILE_REQUEST_RECORD_WATCHER";
export const ADD_FILE_REQUEST_RECORD_SUCCESS =
  "ADD_FILE_REQUEST_RECORD_SUCCESS";
export const ADD_FILE_REQUEST_RECORD_ERROR = "ADD_FILE_REQUEST_RECORD_ERROR";

export const SAVE_EDI_REQUEST_WATCHER = "SAVE_EDI_REQUEST_WATCHER";
export const SET_SAVE_EDI_REQUEST_SUCCESS = "SET_SAVE_EDI_REQUEST_SUCCESS";
export const SET_SAVE_EDI_REQUEST_ERROR = "SET_SAVE_EDI_REQUEST_ERROR";

export const CREATE_EDI_REQUEST_WATCHER = "CREATE_EDI_REQUEST_WATCHER";
export const SET_CREATE_EDI_REQUEST_SUCCESS = "SET_CREATE_EDI_REQUEST_SUCCESS";
export const SET_CREATE_EDI_REQUEST_ERROR = "SET_CREATE_EDI_REQUEST_ERROR";

export const FETCH_EDIDATA_REQUEST = "FETCH_CBPRESPONSE_REQUEST";
export const FETCH_EDIDATA_SUCCESS = "FETCH_CBPRESPONSE_SUCCESS";
export const FETCH_EDIDATA_FAILURE = "FETCH_CBPRESPONSE_FAILURE";

export const FETCH_EDI_RESPONSE_RECORD_REQUEST =
  "FETCH_EDI_RESPONSE_RECORD_REQUEST";
export const FETCH_EDI_RESPONSE_RECORD_SUCCESS =
  "FETCH_EDI_RESPONSE_RECORD_SUCCESS";
export const FETCH_EDI_RESPONSE_RECORD_FAILURE =
  "FETCH_EDI_RESPONSE_RECORD_FAILURE";

export const CLEAR_EDI_RESPONSE_RECORDS = "CLEAR_EDI_RESPONSE_RECORDS";
export const FETCH_EDI_REQUEST_RECORD_REQUEST =
  "FETCH_EDI_REQUEST_RECORD_REQUEST";
export const FETCH_EDI_REQUEST_RECORD_SUCCESS =
  "FETCH_EDI_REQUEST_RECORD_SUCCESS";
export const FETCH_EDI_REQUEST_RECORD_FAILURE =
  "FETCH_EDI_REQUEST_RECORD_FAILURE";
export const CLEAR_EDI_REQUEST_RECORDS = "CLEAR_EDI_REQUEST_RECORDS";

export const FETCH_EDI_FORMAT = "FETCH_EDI_FORMAT";
export const SET_EDI_FORMAT = "SET_EDI_FORMAT";

export const CREATE_EDI_RECORD_REQUEST = "CREATE_EDI_RECORD_REQUEST";
export const CREATE_EDI_RECORD_SUCCESS = "CREATE_EDI_RECORD_SUCCESS";
export const CREATE_EDI_RECORD_FAILURE = "CREATE_EDI_RECORD_FAILURE";

export const STORE_SELECTED_EDI_RECORDS = "STORE_SELECTED_EDI_RECORDS";
export const CLEAR_SELECTED_EDI_RECORDS = "CLEAR_SELECTED_EDI_RECORDS";

export const DELETE_EDI_RECORD_REQUEST = "DELETE_EDI_RECORD_REQUEST";
export const DELETE_EDI_RECORD_SUCCESS = "DELETE_EDI_RECORD_SUCCESS";
export const DELETE_EDI_RECORD_FAILURE = "DELETE_EDI_RECORD_FAILURE";
export const SET_POPUP_RECORDS = "SET_POPUP_RECORDS";
export const SET_POPUP_FLAG = "SET_POPUP_FLAG";

export const FILE_EDI_RECORD_REQUEST = "FILE_EDI_RECORD_REQUEST";
export const FILE_EDI_RECORD_SUCCESS = "FILE_EDI_RECORD_SUCCESS";
export const FILE_EDI_RECORD_FAILURE = "FILE_EDI_RECORD_FAILURE";

export const CLEAR_FILE_SUCCESS_POPUP = "CLEAR_FILE_SUCCESS_POPUP";
export const CLEAR_RECORD_CREATED_POPUP = "CLEAR_RECORD_CREATED_POPUP";
export const CLEAR_RECORD_DELETED_POPUP = "CLEAR_RECORD_DELETED_POPUP";

export const GET_FILE_TOKEN_REQUEST = "GET_FILE_TOKEN_REQUEST";
export const GET_FILE_TOKEN_SUCCESS = "GET_FILE_TOKEN_SUCCESS";
export const GET_FILE_TOKEN_FAILURE = "GET_FILE_TOKEN_FAILURE";
export const CLEAR_TOKEN_RESPONSE = "CLEAR_TOKEN_RESPONSE";
